import homeJson from './content/home.json';

export const homeMock = {
    layoutType: 1,
    data: {
        name: 'home',
        areasList: [
            {
                id: 1,
                name: 'HomePage',
                componentName: 'Comp:HomePage',
                content: JSON.stringify(homeJson)
            }
        ]
    }
};
